import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MenuBar from './pages/MenuBar/MenuBar';
import Home from './pages/Home/Home';
import Whatisit from './pages/Whatisit/Whatisit';
import Example from './pages/Example/Example';
import Tool from './pages/Tool/Tool';
import Publications from './pages/Publications/Publications';
import Header from './pages/Header/Header';
import Footer from './pages/Footer/Footer';
import Login from './pages/Login/Login';
import Singup from './pages/Singup/Singup';
import UrbanCircularity from './pages/UrbanCircularity/UbanCircularity';
import History from './pages/History/History';

import Comp2 from './pages/Comp2/Comp2';
import Comp3 from './pages/Comp3/Comp3';

import Component1 from './pages/Quiz/Component1/Component1';
import Component2 from './pages/Quiz/Component1/Component2/Component2';

import ResetPassword from './pages/ResetPassword/ResetPassword';

import ForgotPassword from './pages/ForgotPassword/ForgotPassword';



function App() {
  return (
    <Router>
      <div className="App">
        <Header/>
        <MenuBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/whatisit" element={<Whatisit />} />
          <Route path="/example" element={<Example />} />
          <Route path="/tool" element={<Tool />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/login" element={<Login />} />
          <Route path="/singup" element={<Singup />} />
          <Route path="/urban" element={<UrbanCircularity />} />
          <Route path="/history" element={<History />} />


           <Route path="/comp2" element={<Comp2 />} />
           <Route path="/comp3" element={<Comp3 />} />
          
          <Route path="/component1" element={<Component1 />} />
          <Route path="/component2" element={<Component2/>}/>

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

        </Routes>
        <Footer className='footer'/>
      </div>
    </Router>
  );
}

export default App;
